


export default class ImageCache {

  constructor() {
    this.images = new Object();
    this.emptyImage = new Image();
    // This dataUrl is a 1x1 transparent image.
    this.emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }

  addImage(imageName) {
    this.images[imageName] = new Image();
    this.images[imageName].src = imageName;
  }

  getImage(imageName) {
    if (!imageName) return;
    if (imageName in this.images) {
      // Do nothing.
    }
    else {
      if (imageName) this.addImage(imageName);
    }
    if (this.images[imageName] && this.images[imageName].naturalHeight > 0) {
      return this.images[imageName];
    }
    else {
      // If the image is broken, return an empty image instead,
      // to prevent Javascript errors when attempting to draw it.
      return this.emptyImage;
    }
  };

}
